
import { getItemByValueId }      from "@/shared/helpers";
import { especialidadService }   from '@/shared/services';
import { atencionMedicaService } from '@/views/atencionMedica/services';

export const servicioOpts = [
  { value: '1', text: 'Emergencia' },
  { value: '2', text: 'Consulta Externa' },
  { value: '3', text: 'Hospitalización' }, 
];

export const estadosInterconsultas = [
  { value: '1',  text:'Completado' },
  { value: '99', text:'Por completar' },
];

export const tipoInterconsultas = [
  { value: '1',  text:'Solicitud' },
  { value: '2',  text:'Informe' },
]


export const interconsultaMapper = async ( raw, especialidades ) => {

  if(!raw){
    console.error('dataInterconsulta is not defined');
    return null;
  }

  const { 
    id, token,
    atencionMedica, 
    cuadroClinico, 
    fechaInterconsulta, 
    motivo, 
    resultadoExamenes, 
    planTerapeutico, 
    diagnosticos,
  } = raw;

  const especialidadesOpts = especialidades || await especialidadService.getOptionsSelect(); 

  const esUrgente    = raw.esUrgente === '1';
  const especialidad = getItemByValueId( especialidadesOpts, raw.especialidad?.id );
  const servicio     = getItemByValueId( servicioOpts, raw.servicio ) || { value: '0', text: 'No asignado' };
  const getAtencion  = await atencionMedicaService.getPacienteDoctorEstab(raw.atencionMedica.id);

  if(!getAtencion) return null;

  const doctor       = `${getAtencion?.doctor.idPersona.primerApellido} ${getAtencion?.doctor.idPersona.primerNombre}`;
  const paciente     = `${getAtencion.paciente.persona.identificacion} - ${getAtencion.paciente.persona.primerApellido} ${getAtencion.paciente.persona.primerNombre}`;

  const establecimiento = { 
    value: getAtencion.establecimiento.id, 
    text: getAtencion.establecimiento.Descripcion 
  };

  const estado = getItemByValueId( estadosInterconsultas, raw.estadoInterconsulta );
  let diagnosticosMap = [];

  const tipo = getItemByValueId( tipoInterconsultas, raw.tipo );

  try{
    diagnosticosMap = JSON.parse( diagnosticos )
  }catch(e){
    diagnosticosMap = []
  }
   
  const interconsultaMapped = {
    id, token,
    atencionMedica,
    fechaInterconsulta,
    esUrgente,
    especialidad,
    servicio,
    cuadroClinico,
    motivo,
    resultadoExamenes,
    planTerapeutico,
    doctor,
    paciente,
    establecimiento,
    estado,
    tipo,
    diagnosticos: diagnosticosMap
  };

  return interconsultaMapped;
}



export const interconsultaMapperBackend = ( raw ) => {

  const tipo =  raw.tipo.value
  const isInforme   = tipo === '2';
  const isSolicitud = tipo === '1';

  const interconsultaMapped = {
    tokenInterconsulta  : raw.token,
    id                  : raw.id,
    fechaInterconsulta  : raw.fechaInterconsulta,
    esUrgente           : raw.esUrgente ? '1' : '0',
    servicio            : raw.servicio.value,
    especialidad        : raw.especialidad.value,
    motivo              : raw.motivo,
    cuadroClinico       : raw.cuadroClinico,
    resultadoExamenes   : isSolicitud ? raw.resultadoExamenes : 'NO APLICA',
    criterioClinico     : isInforme ? raw.criterioClinico : 'NO APLICA',
    planDiagnostico     : isInforme ? raw.planDiagnostico : 'NO APLICA',
    planTerapeutico     : raw.planTerapeutico,
    diagnosticos        : JSON.stringify( raw.diagnosticos ),
    estadoInterconsulta : raw.estadoInterconsulta
  }

  return interconsultaMapped;
}

